module.exports = __webpack_public_path__ + "img/img8.8548f915.png";